<template>
<div>
<!-- main slider section state  -->
<div id="carouselExample" class="carousel slide mobile-manu-top" data-bs-ride="carousel" data-bs-interval="3000">
<!-- Indicators -->
<div class="carousel-indicators">
<button type="button" v-for="(slider, index) in sliders" :key="slider.id" :data-bs-target="'#carouselExample'" :data-bs-slide-to="index" :class="{ active: index === 0 }" aria-label="Slide {{ index + 1 }}"></button>
</div>
<div class="carousel-inner">
<div v-for="(slider, index) in sliders" :key="slider.id" :class="['carousel-item', { active: index == 0 }]">
<!-- Image and overlay -->
<div class="carousel-image-container position-relative">
<img :src="adminurl + 'fontend/slider/' + slider.image" class="d-block w-100" alt="Slide {{ index + 1 }}">
<!-- Overlay -->
<div class="carousel-overlay position-absolute top-0 start-0 w-100 h-100 opacity-50"></div>
</div>
<!--      <div id="CarouselCaption" class="carousel-caption d-none d-md-block"><h5 class="text-white fs-sm-1 fs-head ">{{ slider.headtitle }}</h5><p class="slider-sub ">{{ slider.subtitle }}</p><router-link to="/appointment" class="fs-2 mt-3 btn btn-thm  cs-slider-btn">{{ slider.link }}</router-link></div> -->
</div>
</div>
<!-- Controls -->
<button class="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button>
</div>
<!-- main slider section end  -->
<!-- appoinment btn section state -->
<div id="ApointmentGroupBtn" class="bg-apointment-group">
<div class="container">
<div class="row">
<div class="col-sm-12 col-md-12 col-lg-3">
<div class="bg-overlayer">
<router-link to="/appointment" class="d-flex align-items-center text-white costom-apointment">
<i class="fa fa-inbox font-size-30 px-2"></i> Book Appointment <i class="fa fa-angle-right font-size-30 ps-4 "></i>
</router-link>
</div>
</div>
<div class="col-sm-12 col-md-12 col-lg-3">
<div class="bg-overlayer ">
<router-link to="/doctors" class="d-flex align-items-center text-white costom-apointment">
<i class="fa fa-address-book-o font-size-30 px-2"></i> Find Your Doctor <i class="fa fa-angle-right font-size-30 ps-5 "></i>
</router-link>
</div>
</div>
<div class="col-sm-12 col-md-12 col-lg-6">
<a href="tel:01730033110">
<div class="text-end background-images">
<!-- <img src="images/logo/hotline.png" alt="">  -->
</div>
</a>
</div>
</div>
</div>
</div>
<!-- mobile section appointment state -->
<div id="mobileApointment" class="container-fluid">
<div class="row">
<div class="col-sm-12">
<router-link to="/appointment">
<div class="mobile-apoimtment-btn ">
<div class="mobile-overly-bg py-5">
<a>
<i class="mx-4 fa fa-inbox mobile-appoinment "></i>Book Appointment <i class="mobile-appoint-icon-right me-5 pt-3 fa fa-angle-right"></i>
</a>
</div>
</div>
</router-link>
</div>
<div class="col-sm-12">
<router-link to="doctors">
<div class="mobile-apoimtment-btn  ">
<div class="mobile-overly-bg py-5">
<a>
<i class="mx-4 fa fa-user mobile-appoinment "></i>Find Your Doctor <i class="mobile-appoint-icon-right me-5 pt-3 fa fa-angle-right"></i>
</a>
</div>
</div>
</router-link>
</div>
<div class="col-sm-12">
<div class="mobile-apoimtment-btn">
<div class="mobile-overly-bg py-5">
<a href="tel:01730033110">
<img class="w-100" src="images/logo/hotline.png" alt="">
</a>
</div>
</div>
</div>
</div>
</div>
<!-- appoinment btn section end -->
<!-- appoinment section state -->
<div id="mr-hide" class="ulockd-appointment-form-one pb70 pt70">
<div class="container">
<div class="row">
<div class="col-sm-12 col-md-12 col-lg-6">
<div class="tretment-bg-img">
<h3 class="prime-clg">Prime Medical College Hospital</h3>
<h3 class="world-class text-dark">world </h3>
<h3 class="world-class text-dark">CLASS</h3>
<h3 class="tretment">treatment</h3>
<h3 class="low-cost">At Reasonable cost<span class=""></span></h3>
<div class="lowcost-border m-5"></div>
</div>
</div>

<div class="col-sm-12 col-md-12 col-lg-6">
<div class="row appointment_form_one mt60 box-booking">
<div class="col-sm-12 col-md-12 col-lg-12">
<h2 class="text-thm">Book an Appointment</h2>
<p>We Will Respond As Soon As Possible.</p>
</div>
<div class="col-sm-12 col-md-12 col-lg-6">
<div class="input-group mb-4">
<span class="input-group-text h-45  bg-blue">
<i class="fas fa-calendar-plus text-white fs-4"></i>
</span>
<select v-model="selectedSpecialty" class="selectforch form-control h-45 required ps-5" required=""
data-error="Selection is required.">
<option value=""> Select Department</option>
<option v-for="doctorInformation in doctorInformations" :key="doctorInformation.id"
:value="doctorInformation.id">{{ doctorInformation.title }}</option>
</select>
</div>
</div>

<div class="col-sm-12 col-md-12 col-lg-6">
<div class="input-group mb-4">
<span class="input-group-text h-45 bg-blue">
<i class="fas fa-stethoscope text-white fs-sm-1 fs-4"></i>
</span>
<select v-model="doctorId" class=" form-control selectforch h-45 required ps-5" required=""
data-error="Selection is required.">
<option value="">-- select Doctor --</option>
<option v-for="filteredDoctor in filteredDoctors" :value="filteredDoctor.id"
:key="filteredDoctor.id">{{ filteredDoctor.name }}</option>

</select>
</div>
</div>

<div class="col-sm-12 col-md-12 col-lg-6">
<!--   <span v-if="errorSentVerify" class="text-danger">{{ errorSentVerify }}</span>  -->
<div class="input-group">
<span class="input-group-text h-45 bg-blue fs-sm-1 fs-4">
<i class="fa fa-phone text-white"></i>
</span>
<input id="phonevarification" v-model="phone" type="text" class=" inputforch form-control" placeholder="Contact Number"
required>
<span  v-if="notvarified"@click="phoneotpsend()">
</span>     
<span style="cursor:pointer;" v-if="varified"  @click="phoneotpsend()" ></span> 
</div>
</div>

<div class="col-sm-12 col-md-12 col-lg-6">
<div class="input-group">
<span v-if="formErrors.name" class="text-danger">{{ formErrors.name[0] }}</span>
<span class="input-group-text h-45 bg-blue fs-sm-1 fs-4">
<i class="fa fas fa-user text-white"></i>
</span>
<input v-model="name" type="text" class=" inputforch form-control" placeholder="Patient Name"
required>
</div>
</div>


<div class="col-sm-6 col-md-12 col-lg-6">
<div class="input-group">
<span v-if="formErrors.email" class="text-danger">{{ formErrors.email[0] }}</span>
<span class="input-group-text h-45 bg-blue fs-sm-1 fs-4">
<i class="fa fa-envelope text-white"></i>
</span>
<input v-model="email" type="email" class=" inputforch form-control"
placeholder="Email Address">
</div>
</div>

<!-- Phone Number Input -->
<div class="col-sm-6 col-md-12 col-lg-6">
<div class="input-group">
<span class="input-group-text h-45 bg-blue fs-sm-1 fs-4">
<i class="fa fa-calendar-o text-white"></i>
</span>
<input type="date" v-model="date" :class="{ 'is-invalid': errorMessage }" @change="showDateAlert"
class="inputforch form-control" placeholder="-- Select Date --">
<div v-if="errorMessage" class="invalid-feedback errormassages">
{{ errorMessage }}
</div>
</div>
</div>
<a v-if="otpbtn" @click="phoneotpsend()"
class="fs-sm-1 fs-md-1 py-3 btn btn-apt cs-slider-btn">Send OTP</a>   
<a v-if="btnbookd" @click="Patient_Registration()"class="fs-sm-1 fs-md-1 py-3 btn btn-apt cs-slider-btn">Book Appointment</a>
<!-- <p class="fs-5">Powered by <span><a class="text-info" href="">Nsm Limited</a></span></p> -->

</div>
</div>
</div>
</div>
</div>


<!-- mobile Appointment state -->
<div id="mrDiagnosis" class="ulockd-appointment-form-one pb70 pt70">
<div class="container-fluid">
<div class="row">
<div class="col-sm-12">
<div class="mr-head-title">
<h1 class="mr-btn-book">BOOK AN <br>APPOINMENT</h1>
</div>
</div>
<div class="col-sm-12 col-md-12 col-lg-6">
<div class="row appointment_form_one mt60 box-booking">
<div class="col-sm-12 col-md-12">
<div class="input-group mb-4">
<span class="input-group-text h-45  bg-blue">
<i class="fas fa-calendar-plus text-white"></i>
</span>
<select v-model="selectedSpecialty" class="selectforch form-control h-45 required ps-5" required=""
data-error="Selection is required.">
<option value=""> Select Department</option>
<option v-for="doctorInformation in doctorInformations" :key="doctorInformation.id"
:value="doctorInformation.id">{{ doctorInformation.title }}</option>
</select>
</div>
</div>

<div class="col-sm-12 col-md-12">
<div class="input-group mb-4">
<span class="input-group-text h-45 bg-blue">
<i class="fas fa-stethoscope text-white"></i>
</span>
<select v-model="doctorId" class=" form-control selectforch h-45 required ps-5" required=""
data-error="Selection is required.">
<option value="">-- select Doctor --</option>
<option v-for="filteredDoctor in filteredDoctors" :value="filteredDoctor.id"
:key="filteredDoctor.id">{{ filteredDoctor.name }}</option>

</select>
</div>
</div>


<div class="col-sm-12 col-md-12 col-lg-6">
<!--   <span v-if="errorSentVerify" class="text-danger">{{ errorSentVerify }}</span>  -->
<div class="input-group">
<span class="input-group-text h-45 bg-blue">
<i class="fa fa-phone text-white"></i>
</span>
<input id="phonevarification" v-model="phone" type="text" class=" inputforch form-control" placeholder="Contact Number"
required>
<span  v-if="notvarified"@click="phoneotpsend()">
</span>     
<span style="cursor:pointer;" v-if="varified"  @click="phoneotpsend()" ></span> 
</div>
</div>
<!-- <div class="col-sm-12">
<div class="input-group">
<span class="input-group-text h-45 bg-blue ">
<i class="fa fa-phone text-white"></i>
</span>
<input id="phonevarification" v-model="phone" type="text" class=" inputforch form-control" placeholder="Contact Number"
required>
<span  v-if="notvarified"@click="phoneotpsend()">
</span>     
<span style="cursor:pointer;" v-if="varified"  @click="phoneotpsend()" ></span> 
</div>
</div> -->

<div class="col-sm-12">
<div class="input-group">
<span class="input-group-text h-45 bg-blue ">
<i class="fa fas fa-user text-white"></i>
</span>
<input v-model="name" type="text" class=" inputforch form-control" placeholder="Patient Name"
required>
</div>
</div>

<div class="col-sm-12 ">
<div class="input-group">
<span class="input-group-text h-45 bg-blue ">
<i class="fa fa-envelope text-white"></i>
</span>
<input v-model="email" type="email" class=" inputforch form-control"
placeholder="Email Address ( optional )">
</div>
</div>

<!-- Phone Number Input -->
<div class="col-sm-12">
<div class="input-group">
<span class="input-group-text h-45 bg-blue">
<i class="fa fa-calendar-o text-white"></i>
</span>
<input type="date" v-model="date" :class="{ 'is-invalid': errorMessage }" @change="showDateAlert"
class="inputforch form-control">
<div v-if="errorMessage" class="error_custom invalid-feedback errormassages">
{{ errorMessage }}
</div>
</div>
</div>
<a v-if="otpbtn" @click="Patient_Registration()"
class="fs-sm-1 fs-md-1 py-3 btn btn-apt cs-slider-btn">Send OTP</a>   
<a v-if="btnbookd" @click="Patient_Registration()"class="fs-sm-1 fs-md-1 py-3 btn btn-apt cs-slider-btn">Book Appointment</a>
<!-- <p class="fs-5">Powered by <span><a class="text-info" href="">Nsm Limited</a></span></p> -->

</div>
</div>


</div>
</div>
</div>
<!-- mobile Appointment end -->
<!-- appoinment section end -->
<!-- our services state -->
<div id="mr-hide" class="ulockd-servces-one pt70 pb70  bg-custom">
<div class="container">
<div class="row">
<div class="col-lg-6 offset-lg-3 text-center">
<div class="main-title hvr-float-shadow">
<h2 class="text-uppercase">Our <span class="text-thm">Services</span>
</h2>
</div>
</div>
</div>
<div class="row">
<div v-for="allService in allServices" :key="allService.id" class="col-sm-12 col-xl-4">
<a v-if="allService.id == 8" :href="url + 'Card-service'">
<div class="ulockd-srvcs-column text-center service-area">
<div class="ulockd-srvcs-thumb">
<img class="img-fluid img-whp" :src="this.adminurl + 'fontend/service/' + allService.image" alt="">
<div class="ulockd-srvcs-overlay">
<div class="ulockd-srvcs-icon">
<a class="lightbox-image" data-fancybox-group="preject" :href="this.url + 'Card-service'">View Details</a>
</div>
</div>
</div>
<div class="ulockd-srvc-contnt">
<h3 class="title">
<a>{{ allService.title }}</a>
</h3>
<p class="align-justify fs-sm-1 fs-md-1 h-93">{{ allService.description }}</p>
</div>
</div>
</a>
<a v-else-if="allService.id == 7" :href="url + 'Cabin-service'">
<div class="ulockd-srvcs-column text-center service-area">
<div class="ulockd-srvcs-thumb">
<img class="img-fluid img-whp" :src="this.adminurl + 'fontend/service/' + allService.image" alt="">
<div class="ulockd-srvcs-overlay">
<div class="ulockd-srvcs-icon">
<a class="lightbox-image" data-fancybox-group="preject" :href="this.url + 'Cabin-service'">View Details</a>
</div>
</div>
</div>
<div class="ulockd-srvc-contnt">
<h3 class="title">
<a>{{ allService.title }}</a>
</h3>
<p class="align-justify fs-sm-1 fs-md-1 h-93">{{ allService.description }}</p>
</div>
</div>
</a>
<a v-else :href="url + 'Diagnostics'">
<div class="ulockd-srvcs-column text-center service-area">
<div class="ulockd-srvcs-thumb">
<img class="img-fluid img-whp" :src="this.adminurl + 'fontend/service/' + allService.image" alt="">
<div class="ulockd-srvcs-overlay">
<div class="ulockd-srvcs-icon">
<a class="lightbox-image" data-fancybox-group="preject" :href="this.url + 'Diagnostics'">View Details</a>
</div>
</div>
</div>
<div class="ulockd-srvc-contnt">
<h3 class="title">
<a>{{ allService.title }}</a>
</h3>
<p class="align-justify fs-sm-1 fs-md-1 h-93">{{ allService.description }}</p>
</div>
</div>
</a>
</div>
</div>
</div>
</div>
<!-- mobile service state -->
<div id="servicesMobile" class="ulockd-servces-one pt70 pb70  bg-custom">
<div class="container-fluid">
<div class="row">
<div class="col-lg-6 offset-lg-3 text-center">
<div class="main-title hvr-float-shadow">
<h2 class="text-uppercase">Our <span class="text-thm">Services</span>
</h2>
</div>
</div>
</div>
<div class="row">
<div v-for="allService in allServices" :key="allService.id" class="col-sm-12 col-xl-4">
<a v-if="allService.id == 8" :href="url + 'Card-service'">
<div class="ulockd-srvcs-column text-center service-area">
<div class="ulockd-srvcs-thumb">
<img class="img-fluid img-whp" :src="this.adminurl + 'fontend/service/' + allService.image" alt="">
<div class="ulockd-srvcs-overlay">
<div class="ulockd-srvcs-icon">
<a class="lightbox-image" data-fancybox-group="preject" :href="this.url + 'Card-service'">View Details</a>
</div>
</div>
</div>
<div class="ulockd-srvc-contnt">
<h3 class="title">
<a>{{ allService.title }}</a>
</h3>
<p class="align-justify fs-sm-1 fs-md-1">{{ allService.description }}</p>
</div>
</div>
</a>
<a v-else-if="allService.id == 7" :href="url + 'Cabin-service'">
<div class="ulockd-srvcs-column text-center service-area">
<div class="ulockd-srvcs-thumb">
<img class="img-fluid img-whp" :src="this.adminurl + 'fontend/service/' + allService.image" alt="">
<div class="ulockd-srvcs-overlay">
<div class="ulockd-srvcs-icon">
<a class="lightbox-image" data-fancybox-group="preject" :href="this.url + 'Cabin-service'">View Details</a>
</div>
</div>
</div>
<div class="ulockd-srvc-contnt">
<h3 class="title">
<a>{{ allService.title }}</a>
</h3>
<p class="align-justify fs-sm-1 fs-md-1 ">{{ allService.description }}</p>
</div>
</div>
</a>
<a v-else :href="url + 'Diagnostics'">
<div class="ulockd-srvcs-column text-center service-area">
<div class="ulockd-srvcs-thumb">
<img class="img-fluid img-whp" :src="this.adminurl + 'fontend/service/' + allService.image" alt="">
<div class="ulockd-srvcs-overlay">
<div class="ulockd-srvcs-icon">
<a class="lightbox-image" data-fancybox-group="preject" :href="this.url + 'Diagnostics'">View Details</a>
</div>
</div>
</div>
<div class="ulockd-srvc-contnt">
<h3 class="title">
<a>{{ allService.title }}</a>
</h3>
<p class="align-justify fs-sm-1 fs-md-1">{{ allService.description }}</p>
</div>
</div>
</a>
</div>
</div>
</div>
</div>
<!-- mobile service end -->
<!-- our services end -->
<!-- our swiper slider section state -->
<div class="my-5 swiper-container swiper mySwiper" ref="swiperContainer">
<div class="row">
<div class="col-lg-6 offset-lg-3 text-center">
<div class="main-title hvr-float-shadow">
<h2 class="text-uppercase">Our <span class="text-thm">Doctors</span>
</h2>
</div>
</div>
</div>
<div ref="swiperContainer" class="swiper-wrapper" data-swiper-pauseonmouseenter="true">
<div class="swiper-slide swiper-border col-12 col-sm-6 col-md-4 col-lg-3" v-for="(slide, index) in this.doctorSliders" :key="index">
<router-link :to="`/doctor-details/${slide.id}`">
<img :src="this.adminurl + 'doctor/' + slide.image" :alt="slide.image" class="img-fluid" />
<div class="swiper-text slide-content">
<div class="btn-apt ">
<h3>
<router-link :to="`/doctor-details/${slide.id}`" class="p-4 swiper-text  text-white btn-apt fs-2">{{ truncateText(slide.name) }}</router-link>
</h3>
</div>
<p class="swiper-text">{{ getLimitedWords(slide?.specialitys?.title || '') }}
</p>
</div>
</router-link>
</div>
</div>
</div>
<!-- our swiperslider  section end -->
<section v-for="whychoice in whychoices" :key="whychoice.id" id="mr-hide" class="ulockd-team-one">
<div class="container">
<div class="wrapper bgc-f7 pt60 pb30 px-5">
<div class="row">
<!-- Check if image_position is 'Left' or 'Right' and adjust column order accordingly -->
<div :class="['col-sm-12', 'col-md-12', 'col-lg-6', whychoice.image_position == 'Left' ? 'order-2' : 'order-1']">
<div class="ulockd-srvc-contnt">
<h3 class="title">
<a>{{ whychoice.title }}</a>
</h3>
<p class="text-justify">{{ whychoice.description }}</p>
</div>
</div>
<div :class="['col-sm-12', 'col-md-12', 'col-lg-6', whychoice.image_position == 'Left' ? 'order-1' : 'order-2']">
<div class="ulockd-team-member mb30">
<div class="ulockd-tm-thumb">
<img class="img-fluid img-whp" :src="this.adminurl + 'fontend/whychoice/' + whychoice.image" alt="Service Image" />
<div class="ulockd-tm-overlay one text-start">
<div class="ulockd-tm-name">{{ whychoice.title }}</div>
<p class="text-justify">{{ whychoice.description }}</p>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</section>
<!-- moile section state -->
<section v-for="whychoice in whychoices" :key="whychoice.id" id="whymobileShow" class="ulockd-team-one">
<div class="container-fluid">
<div class="wrapper bgc-f7 p30 mb30">
<div class="row">
<div class="col-sm-12 col-md-12 col-lg-6">
<div class="ulockd-srvc-contnt">
<h3 class="title">
<a>{{ whychoice.title }}</a>
</h3>
<p class="text-justify">{{ whychoice.description }}</p>
</div>
</div>
<div class="col-sm-12 col-md-12 col-lg-6">
<div class="ulockd-team-member mb30">
<div class="ulockd-tm-thumb">
<img class="img-fluid img-whp" :src="this.adminurl + 'fontend/whychoice/' + whychoice.image" alt="Service Image" />
<div class="ulockd-tm-overlay one text-start">
<div class="ulockd-tm-name">{{ whychoice.title }}</div>
<p class="text-justify">{{ whychoice.description }}</p>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</section>
<!-- moile section state -->
<!-- why Pmc end  -->
<section>
<!-- appointment  Divider state -->
<div id="mr-hide" class="bg-black padding-top-buttom">
<div class="adjustable-container container">
<div class="row">
<div class="col-sm-9 col-md-7 col-lg-9">
<div class="text-center text-md-start mb20-sm">
<h2 class="ulockd-dvidr-mttl">We provide high-quality and affordable services for you.</h2>
</div>
</div>
<div class="col-sm-3 col-md-5 col-lg-3">
<div class="ulockd-dvidr-btn text-uppercase text-center text-md-end mt0">
<router-link to="/appointment" class=".btn-apt btn btn-default btn-white hvr-overline-from-center" href="#">Get Appointment</router-link>
</div>
</div>
</div>
</div>
</div>
<!--  appointment  Divider end -->
</section>
<!-- our expart section state -->
<section id="mr-hide" class="pt70 pb70">
<div class="container">
<div class="row">
<div class=" col-md-12 col-lg-6 offset-lg-3 text-center">
<div class="main-title hvr-float-shadow">
<h2 class="text-uppercase">Our Management <span class="text-thm">Team</span>
</h2>
</div>
</div>
</div>
<div class="row">
<div v-for="management in managements" :key="management.id" style="width: 20%; margin: 0 auto;">
<router-link :to="`/manegments/${management.categori_id}`">
<div class="ulockd-team-two-member">
<div class="ulockd-tm-thumb">
<!-- Dynamically bind the image source -->
<img style="height: 250px;" class="img-fluid img-whp" :src="adminurl + 'fontend/management/' + management.image" alt="Management Image">
</div>
</div>
</router-link>
</div>
</div>
</div>
</section>
<!-- mobile varsion manegment state  -->
<section id="whymobileShow" class="pt70 pb70">
<div class="container-fluid">
<div class="row">
<div class=" col-md-12 col-lg-6 offset-lg-3 text-center">
<div class="main-title hvr-float-shadow">
<h2 class="text-uppercase">Our Management <span class="text-thm">Team</span>
</h2>
</div>
</div>
</div>
<div class="row">
<div v-for="management in managements" :key="management.id" class="col-sm-6 col-md-6 col-lg-3">
<div class="ulockd-team-two-member">
<div class="ulockd-tm-thumb">
<!-- Dynamically bind the image source -->
<img class="m-h-1000 img-fluid img-whp " :src="adminurl + 'fontend/management/' + management.image" alt="Management Image">
</div>
</div>
</div>
</div>
</div>
</section>
<!-- mobile varsion manegment end  -->
<!-- our expart section end -->
<!-- photo album end -->
<section :style="{
backgroundColor: 'red',
backgroundAttachment: 'fixed',
backgroundImage: `url('./images/upcoming/5 (3).jpg')`,
backgroundPosition: 'center center'
}" class="ulockd-service-three bg-gallery-img pb70">
<div class="container">
<div class="row">
<div class="col-lg-6 offset-lg-3 text-center">
<div class="main-title hvr-float-shadow">
<h2 class="text-uppercase">Our Photo <span class="text-thm"> Album</span>
</h2>
</div>
</div>
</div>
<div class="row">
<div class="col-sm-12 col-md-12 col-lg-12">
<div class="masonry-isotop">
<!-- Masonry Filter -->
<ul class="masonry-filter text-center">
<button class="active-all text-white btn btn-default btn-white filter-button me-2 border" data-filter="all">All</button>
<button class="btn btn-default btn-white filter-button me-2 border" data-filter="1">Hub</button>
<button class="btn btn-default btn-white filter-button me-2 border" data-filter="2">Corporate</button>
<button class="btn btn-default btn-white filter-button me-2 border" data-filter="3">Pharmacy</button>
<button class="btn btn-default btn-white filter-button me-2 border" data-filter="4">Consultation</button>
</ul>
<!-- End Masonry Filter -->
<!-- Masonry Grid -->
<div class="row">
<!-- Dynamically display gallery images -->
<div v-for="galleryImage in displayedGalleryImages" :key="galleryImage.id" :class="'col-12 col-sm-12 col-md-6 col-lg-4 gallery-item mb-3 ' + galleryImage.category_id">
<div class="gallery-image position-relative">
<img :src="this.adminurl + 'fontend/Galleryimage/' + galleryImage.image" class="img-fluid hvr-float-shadow">
</div>
</div>
</div>
</div>
</div>
</div>
<!-- Show 'All Departments' button -->
<div class="row">
<div class="col-lg-12">
<div class="text-end mt-5 position-relative z-index-10">
<button class="btn btn-lg py-3 hvr-bounce-to-right" @click="toggleGalleryView">
{{ allPhotosVisible ? 'Cancel' : 'All Departments' }}
<i class="fa" :class="allPhotosVisible ? 'fa-times' : 'fa-arrow-right'"></i>
</button>
</div>
</div>
</div>
</div>
</section>
<!-- photo album end -->
<!-- mobile gallery photo slider  -->
<div id="carouselExampleAutoplaying" class="container-fluid">
<div class="row">
<div class="col-lg-6 offset-lg-3 text-center">
<div class="main-title hvr-float-shadow">
<h2 class="text-uppercase">Our Photo <span class="text-thm">Gallery</span>
</h2>
</div>
</div>
</div>
<div class="carousel slide" data-bs-ride="carousel">
<div class="carousel-inner">
<div v-for="(galleryImage, index) in galleryImages" :key="galleryImage.id" :class="['carousel-item', { active: index == 0 }]">
<img :src="this.adminurl + 'fontend/Galleryimage/' + galleryImage.image" class="d-block w-100" alt="...">
</div>
</div>
<!-- mobile gallery photo slider-->
<button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true">
<i class="fas fa-chevron-left"></i>
<!-- FontAwesome icon for left arrow -->
</span>
<span class="visually-hidden">Previous</span>
</button>
<!-- Next Button with custom icon -->
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true">
<i class="fas fa-chevron-right"></i>
<!-- FontAwesome icon for right arrow -->
</span>
<span class="visually-hidden">Next</span>
</button>
</div>
</div>
<!-- gallery photo slider mobile  -->
</div>
<div id="app">
<div v-if="showModal" class="modal fade show d-block" tabindex="-1">
<div class="modal-dialog modal-xl modal-dialog-centered">
<div class="modal-content">
<div class="modal-header">
<h3 class="modal-title">Registration Forms</h3>
<button type="button" class="btn-close" @click="closeModal"></button>
</div>
<div class="modal-body">
<!-- Phone Field -->
<div  v-if="formErrors.phone" class="text-danger error-styles">{{ formErrors.phone[0] }}</div>
<div class="mb-3 input-group">
<span class="input-group-text bg-primary text-white">
<i class="fa fa-phone"></i>
</span>
<input v-model="phone" type="text" class="form-control" placeholder="Enter Phone">
</div>
<!-- Name Field -->
<div v-if="formErrors.name" class="text-danger error-styles">{{ formErrors.name[0] }}</div>
<div class="mb-3 input-group">
<span class="input-group-text bg-primary text-white"><i class="fa fa-user"></i></span>
<input v-model="name" type="text" class="form-control" placeholder="Enter Name">
</div>


<!-- Email Field -->
<div v-if="formErrors.email" class="text-danger error-styles">{{ formErrors.email[0] }}</div>
<div class="mb-3 input-group">
<span class="input-group-text bg-primary text-white"><i class="fa fa-envelope"></i></span>
<input v-model="email" type="email" class="form-control" placeholder="Enter Email">
</div>
</div>

<div class="modal-footer">
<div class="text-end mt-3"><a class="btn btn-apt px-5">Submit</a></div>
</div>
</div>
</div>
</div>
</div>


<!-- home onload pupup state -->
<div>
<Popup></Popup>
</div>


<div id="app">
<div v-if="otpcode" class="modal fade show d-block" tabindex="-1">
<div class="modal-dialog modal-xl modal-dialog-centered">
<div class="modal-content">
<div class="modal-header">
<button type="button" class="btn-close" @click="otpcode = false "></button>
</div>
<div class="modal-body">
<div class="otp-container">
<h2 class="otp-title">Verification Code</h2>
<p class="otp-description">Please enter the 6-digit code sent to your device</p>

<div class="otp-inputs">
<input
v-for="(digit, index) in otpDigits"
:key="index"
ref="otpInputs"
type="text"
maxlength="1"
class="otp-input"
:class="{ 'otp-error': showOtpError && !digit }"
v-model="otpDigits[index]"
@input="handleInput(index)"
@keydown="handleKeydown($event, index)"
@paste="handlePaste"
/>
</div>

<!-- Error message under inputs -->
<p v-if="showOtpError" class="otp-error-message">{{ errorotp }}</p>

<button class="verify-button" @click="verifyCode">Verify</button>

<div class="resend-container">
<p class="resend-text">
Didn't get a code? <a href="#" class="resend-link" @click.prevent="resendCode">Resend</a>
</p>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>
import Popup from '../components/offerpupup.vue';
import {
onMounted,
ref,
computed
} from "vue";
import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/navigation";
import {
useStore
} from 'vuex';
import Swal from "sweetalert2";
import axios from 'axios';
export default {
components: {
Popup
},
name: "SwiperSlider",
name: 'OtpInput',
watch:{
phone(value){
console.log(value);
axios.get(this.adminurl+'api/phonevarification/'+value).then(response=>{
if(response.data.virification==0){
$('#phonevarification').css('color','red');
this.notvarified=true;
this.varified=false;
this.btnbookd=false;
this.otpbtn=true;

}else{
$('#phonevarification').css('color','green');
this.btnbookd=true;
this.otpbtn=false;
this.notvarified=false;
this.varified=true;
this.email= response.data.user.email;
this.name= response.data.user.name;
}

});
}
},
computed: {
adminurl() {
return this.$store.state.adminurl;
},
url() {
return this.$store.state.url;
},
// Filter doctors based on the selected specialty ID
filteredDoctors() {
if (!this.selectedSpecialty) return [];
const selectedSpecialty = this.doctorInformations.find(specialties => specialties.id == this.selectedSpecialty);
return selectedSpecialty ? selectedSpecialty.doctor : [];
},
isFormValid() {
return !this.errorMessage;
},
},
mounted() {
const swiperContainer = this.$refs.swiperContainer; // Use Vue's ref to access the container
const swiper = new Swiper(swiperContainer, {
slidesPerView: 1, // Default value
spaceBetween: 10, // Default value
pagination: {
el: ".swiper-pagination",
clickable: true,
},
breakpoints: {
640: {
slidesPerView: 1,
spaceBetween: 50,
},
768: {
slidesPerView: 1,
spaceBetween: 50,
},
1024: {
slidesPerView: 3,
spaceBetween: 50,
},
},
autoplay: {
delay: 2000, // Change autoplay delay to your preferred value
disableOnInteraction: false,
},
});
// Stop autoplay on mouseenter
swiperContainer.addEventListener('mouseenter', () => {
swiper.autoplay.stop();
});
// Restart autoplay on mouseleave
swiperContainer.addEventListener('mouseleave', () => {
swiper.autoplay.start();
});
this.services();
this.mainslider();
},
setup() {
const swiperContainer = ref(null); // Vue ref for container
const doctorSliders = ref([]);
const store = useStore();
const adminurl = computed(() => store.state.adminurl);
// Function to fetch slides data
const fetchSlides = async () => {
try {
const response = await axios.get(adminurl.value + 'api/doctorSlider');
// Assign the fetched data to the doctorSliders
doctorSliders.value = response.data;
} catch (error) {
console.error('Error fetching slides data:', error);
}
};
onMounted(() => {
const swiper = new Swiper(swiperContainer.value, {
slidesPerView: 4,
spaceBetween: 20,
autoplay: {
delay: 1000,
disableOnInteraction: false,
},
loop: true,
grabCursor: true,
navigation: {
nextEl: ".swiper-button-next",
prevEl: ".swiper-button-prev",
},
});
// Manually pause and resume autoplay on mouse enter/leave
swiperContainer.value.addEventListener('mouseenter', () => {
swiper.autoplay.stop();
});
swiperContainer.value.addEventListener('mouseleave', () => {
swiper.autoplay.start();
});
fetchSlides(); // Fetch slide data after mounted
});
return {
swiperContainer,
doctorSliders
};
},
data() {
return {
btnbookd: true,
otpbtn:false,
errorSentVerify: '',
errorotp: '',
formErrors: {},
otpDigits: ['', '', '', '', '', ''],
otpcode :false,
Phone_Otpmodal :false,
phoneError: '',
message: '',
otpMessage: '',
showModal: false,
showOtpError: false,
otpcheck: '',
loading: false,
notvarified:true,
varified:false,
sliders: [],
sliderimages: [],
managements: [],
doctorInformations: [],
whychoices: [],
galleryImages: [],
displayedGalleryImages: [],
allPhotosVisible: false,
selectedSpecialty: "",
date: "",
doctorId: "",
name: "",
phone: '',
email: "",
errorMessage: "",
allServices: [],
limit: 9,
fontendotp:'',

};
},
created() {
// Make an AJAX call to the Laravel API Our Management Team
axios.get(this.adminurl + 'api/management').then(response => {
this.managements = response.data.managements;
}).catch(error => {
console.error('Error fetching data:', error);
});
// Make an AJAX call to the Laravel input Appointment
axios.get(this.adminurl + 'api/doctor-information').then(response => {
console.log(response.data);
this.doctorInformations = response.data.specialties;
}).catch(error => {
console.error('Error fetching data:', error);
});
// Fetch gallery images from the backend API
axios.get(this.adminurl + 'api/galleryImageall').then(response => {
// Store the fetched images in the galleryImages array
this.galleryImages = response.data;
console.log('Fetched gallery images:', this.galleryImages);
// Initially display only the first 12 images
this.displayedGalleryImages = this.galleryImages.slice(0, this.limit);
}).catch(error => {
console.error('Error fetching data:', error);
});
// Why Choice Section Service Api
axios.get(this.adminurl + 'api/whychoices').then(response => {
console.log(response.data);
this.whychoices = response.data;
}).catch(error => {
console.error('Error fetching data:', error);
});
},
methods: {      
phoneotpsend(){
this.fontendotp=Math.floor(100000 + Math.random() * 900000);
this.phone;
axios.post(this.adminurl+'api/sendphoneotp',{
otp:this.fontendotp,
phone:this.phone
}).then(response=>{
this.otpcode=true;
});
},
async verifyCode() {
const code = this.otpDigits.join('').trim();

// Basic validation
if (code.length !== 6 || !/^\d{6}$/.test(code)) {
this.errorotp = 'Please enter a valid 6-digit code.';
this.showOtpError = true;
return;
}
if(code==this.fontendotp){
Swal.fire({
toast: true,
position: 'top-end',
icon: 'success',
title: 'Phone is verified',
showConfirmButton: false,
timer: 3000,
width: '500px' // Custom width
});

this.varified=true;
this.notvarified=false;
this.otpcode = false;
}else{
this.errorotp = 'The code you entered is incorrect. Please try again.';
this.notvarified=true;
this.varified=false;
}
},
handleInput(index) {
this.showOtpError = false;
this.errorotp = '';

const value = this.otpDigits[index];
if (value.length === 1 && index < 5) {
this.$refs.otpInputs[index + 1].focus();
}

if (value.length > 1) {
this.otpDigits[index] = value.slice(0, 1);
}
},

handleKeydown(event, index) {
if (event.key === 'Backspace' && !this.otpDigits[index] && index > 0) {
this.$refs.otpInputs[index - 1].focus();
}
},

handlePaste(event) {
const paste = event.clipboardData.getData('text').trim().slice(0, 6);
if (/^\d{6}$/.test(paste)) {
for (let i = 0; i < 6; i++) {
this.otpDigits[i] = paste[i];
}
this.$nextTick(() => {
this.$refs.otpInputs[5].focus();
});
}
event.preventDefault();
},
Patient_Registration() {
	alert("hii");
this.loading = true;

if (this.varified === false) {
this.phoneotpsend();
this.errorSentVerify = "Please send an OTP to verify your number.";  // Error message prompt
this.loading = false;
return;
}else {
 if(this.phone == ''){
 	alert("phone in required")
 }else{
axios.post(this.adminurl + 'api/patiend_registrition', {
name: this.name,
email: this.email,
phone: this.phone,
speciality_id: this.selectedSpecialty,
doctor_id: this.doctorId,
date: this.date,
})
.then(response => {
const width = window.innerWidth;
Swal.fire({
html: `
<div style="font-size: 55px; font-weight: bold;">Success!</div>
<div style="font-size: 20px; margin-top: 10px;">Your doctor's appointment has been successfully!</div>
`,
icon: "success",
confirmButtonText: "OK",
width: width >= 1024 ? '50%' : '90%', 
padding: width >= 1024 ? '3em' : '5em',
showClass: {
popup: 'animate__animated animate__fadeInDown'
},
hideClass: {
popup: 'animate__animated animate__fadeOutUp'
},
customClass: {
confirmButton: 'custom-confirm-button'
},
timer: 3000, // Auto close after 3 seconds
timerProgressBar: true // Shows a progress bar
});

console.log('Appointment saved successfully:', response.data);
})
.catch(error => {
if (error.response && error.response.data && error.response.data.errors) {
this.formErrors = error.response.data.errors;
}
const width = window.innerWidth;
Swal.fire({
html: `
<div style="font-size: 55px; font-weight: bold; color: #e74c3c;">Error!</div>
<div style="font-size: 20px; margin-top: 10px;">Something went wrong. Please try again later.</div>
`,
icon: "error",
confirmButtonText: "OK",
width: width >= 1024 ? '50%' : '90%',
padding: width >= 1024 ? '3em' : '5em',
showClass: {
popup: 'animate__animated animate__fadeInDown'
},
hideClass: {
popup: 'animate__animated animate__fadeOutUp'
},
customClass: {
confirmButton: 'custom-confirm-button'
},
timer: 3000, // Auto-close after 3 seconds
timerProgressBar: true
});

})
.finally(() => {
this.loading = false;
});
}
}
},






async mainslider() {
try {
const response = await axios.get(this.adminurl + 'api/slider');
this.sliders = response.data;
} catch (error) {
console.error('Error fetching sliders:', error);
}
},
truncateText(text, maxWords = 6) {
const words = text.split(' ');
if (words.length > maxWords) {
return words.slice(0, maxWords).join(' ') + '...';
}
return text;
},
getLimitedWords(text) {
const words = text.split(' ');
return words.slice(0, 6).join(' ') + (words.length > 6 ? '...' : '');
},
closeModal() {
this.showModal = false;
},
toggleGalleryView() {
if (this.allPhotosVisible) {
// Reset to showing only the first 12 images
this.displayedGalleryImages = this.galleryImages.slice(0, this.limit);
} else {
// Show all images
this.displayedGalleryImages = this.galleryImages;
}
// Toggle the visibility flag
this.allPhotosVisible = !this.allPhotosVisible;
},
limitDescription(description) {
const words = description.split(' ');
return words.slice(0, 20).join(' ') + (words.length > 20 ? '...' : '');
},
serviceDescription(description) {
const words = description.split(' ');
return words.slice(0, 20).join(' ') + (words.length > 20 ? '...' : '');
},
showDateAlert() {
const currentDate = new Date().toISOString().split('T')[0];
if (this.date && this.date < currentDate) {
this.date = '';
this.errorMessage = 'The date is not allowed!';
} else {
this.errorMessage = '';
axios.get(this.adminurl + 'api/count-appointment', {
params: {
doctorId: this.doctorId,
date: this.date
}
}).then(response => {
console.log(response.data);
if (response.data.status == false) {
this.date = '';
this.errorMessage = response.data.error;
}
}).catch(error => {
console.error("There was an error with the date request:", error);
});
}
},
async services() {
try {
// Replace with your API endpoint if you're fetching this data from a server
const response = await axios.get(this.adminurl + 'api/services');
this.allServices = response.data;
console.log(this.allServices);
} catch (error) {
console.error('Error fetching data:', error);
}
},
}
};
// Filter functionality
$(document).ready(function() {
$(".filter-button").click(function() {
var filter = $(this).data("filter");
if (filter == "all") {
$(".gallery-item").show();
} else {
$(".gallery-item").hide();
$("." + filter).show();
}
});
});
// Add custom CSS for the confirm button font size, title font size, icon font size, and subtitle font size
const width = window.innerWidth;
const style = document.createElement('style');
style.innerHTML = `
.custom-confirm-button {
font-size: 2.5em !important; 
}
.swal2-title {
font-size: 35px !important;  
}
.swal2-icon {
font-size: 20px !important; 
}
`;
document.head.appendChild(style);
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* Loader (spinner) style */
.loader {
    border: 8px solid green;
    border-radius: 50%;
     /* animation: spin-9ea40744 1s linear infinite;  */
}
.loader img {
border-radius: 30px;
}

/* Spinner animation */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.carousel-item .col-6 {
display: flex;
justify-content: center;
}

.cd-full-width {
width: 40%;
margin: 0 auto;
}

.fs-19 {
font-weight: 700;
font-size: 19px;
}

.fs-15 {
font-size: 15px;
}

.text-left {
text-align: left;
}

.mb-7 {
margin-bottom: 68px;
}

.h-600 {
height: 600px;
}

.gallery-item {
position: relative;
overflow: hidden;
}

.gallery-item img {
background-repeat: no-repeat;
image-rendering: pixelated;
height: 170px;
width: 100%;
transition: transform 0.5s ease, opacity 0.5s ease;
background-size: cover;
}

.masonry-isotop .row {
display: flex;
flex-wrap: wrap;
justify-content: space-around;
}

@media (max-width: 767px) {
.gallery-item {
flex: 0 0 48%;
/* Adjust for smaller screen (2 items per row) */
}
}

@media (max-width: 575px) {
.gallery-item {
flex: 0 0 100%;
/* Full width on very small screens */
}
}

.gallery-image[data-v-9ea40744] {
border: 2px solid #008c42;
}

.overlay {
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
background-color: rgba(0, 0, 0, 0.5);
/* Semi-transparent background */
color: white;
visibility: hidden;
/* Hide overlay by default */
opacity: 0;
transition: opacity 0.3s ease, visibility 0s 0.3s;
text-align: center;
padding: 15px;
}

.gallery-image:hover .overlay {
visibility: visible;
background: #3b6997;
display: table-cell;
opacity: 0.70;
transition: opacity 0.3s ease;
}

.active-all {
background: #008c42;
}

.Welcome-description {
font-size: 16px;
padding: 1px;
}

.form-control option.disable {
color: #6c757d;
/* Placeholder color */
}

.form-control:invalid {
color: #6c757d;
/* Match placeholder color */
}

.form-control:valid {
color: #212529;
/* Normal text color */
}

.fs-44 {
font-size: 44px;
}

.fw-200 {
font-weight: 200;
}

.bg-about-se {
background-color: darkgreen;
}

.padding-top-buttom {
padding-top: 50px;
padding-bottom: 40px;
}

.custom-caption {
background-color: rgba(0, 0, 0, 0.5);
/* Semi-transparent black */
padding: 20px;
/* Add some padding for better spacing */
border-radius: 8px;
/* Optional: rounded corners */
}

.h-170 {
height: 170px !important;
}

.h-195 {
height: 195px;
}

.h-116 {
font-size: 16px;
height: 126px;
}

.fs-head {
color: #fff;
font-size: 67px;
font-size: calc(40px + .05vw);
font-weight: 600;
letter-spacing: -.009em;
line-height: 1.3;
text-transform: capitalize;
}

.slider-sub {
font-size: calc(22px + .05vw);
line-height: 1.25;
}

.carousel-image-container {
position: relative;
}

.slider-sub {
color: #e0e0e1;
font-family: Proxima Nova, sans-serif;
font-weight: 400;
font-size: calc(22px + .05vw);
line-height: 1.25;
}

.cs-slider-btn {
text-transform: none;
font-family: inherit;
}

.serchber-home {
box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.5);
}

.bg-overlayer {
background-color: #3FAD4E;
opacity: 0.83;
transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
}

.bg-blue {
background-color: #008c42;
}

.box-booking {
box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2), 0 -10px 20px rgba(0, 0, 0, 0.1);
}

.h-45 {
height: 45px;
}

.btn-apt {
font-weight: 400;
background-color: #003872;
color: #ffffff;
}

.btn-apt:hover {
background-color: #0b2744;
}

.prime-clg {
color: #089928;
}

.world-class {
color: #000000;
font-family: "Exo", sans-serif;
font-size: 64px;
font-weight: 700;
text-transform: uppercase;
line-height: 70px;
}

.tretment {
color: #1A66B1;
font-family: "Exo", sans-serif;
font-size: 64px;
font-weight: 700;
text-transform: uppercase;
line-height: 70px;
}

.low-cost {
color: #222222;
margin: 7px 0px 0px 0px;
font-family: "Exo", sans-serif;
font-size: 36px;
font-weight: 700;
line-height: 48px;
}

.lowcost-border {
width: 50px;
height: 3px;
background-color: #1cba9f;
}

.align-justify {
padding: 0px 18px;
text-align: justify !important;
}

.selectforch:focus {
border-color: #007bff;
box-shadow: 0 0 8px rgba(0, 123, 255, 0.5);
}

.inputforch:focus {
border-color: #007bff;
box-shadow: 0 0 8px rgba(0, 123, 255, 0.5);
}

.h-93 {
height: 155px !important;
}

.errormassages {
margin-left: 31px;
margin-top: -1.75rem;
font-size: .875em;
}

.modal {
display: none;
position: fixed;
z-index: 1;
left: 0;
top: 0;
width: 100%;
height: 100%;
background-color: rgb(0 0 0 / 78%);
}

.modal.show {
display: block;
}

.modal-content {
position: relative;
background-color: white;
margin: 15% auto;
padding: 20px;
width: 80%;
max-width: 600px;
border-radius: 8px;
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.close-btn {
position: absolute;
top: 10px;
right: 10px;
font-size: 28px;
cursor: pointer;
}

.close-btn:hover {
color: #333;
}
</style>